import { type ReactElement } from 'react';

interface ErrorMessageProps {
  message: string | null | undefined;
}
export const ErrorMessage = ({ message }: ErrorMessageProps): ReactElement | null => {
  if (!message) return null;
  return <p className="text-red-500 font-medium text-sm ml-1">{message}</p>;
};
